export type AISummaryItemDto = {
  title: string;
  paragraph: string;
};

export enum AISummaryStatus {
  VERIFIED = 'verified',
  PENDING_REVIEW = 'pending_review',
}

// Hardcoded welcome section title — not part of `AISummarySectionTitle` because the
// welcome video ships via `STATIC_AVATARS`, not the BE AI summary response.
export const WELCOME_SECTION_TITLE = 'What will I get from my results?';

// Section titles returned by the AI Summary service. Values must mirror the BE strings.
export enum AISummarySectionTitle {
  // Manager scope
  ResponseRateAndEngagementScores = 'Response rate and engagement scores',
  HowIsTheTeamFeeling = 'How is the team feeling?',
  WhatHasChanged = 'What has changed?',
  RecommendedFocusAreas = 'Recommended focus areas',

  // Overall scope
  SummaryOfYourResponseRate = 'Summary of your response rate',
  EngagementScores = 'Engagement scores',
  DriversOfEngagement = 'Drivers of engagement',
  Conclusion = 'Conclusion',
}

export type AISummariesDto = {
  id: string;
  sections: AISummaryItemDto[];
  status: AISummaryStatus;
};

export type AISummaryItemModel = AISummaryItemDto;

export type AISummariesModel = {
  id: string;
  sections: AISummaryItemModel[];
  status: AISummaryStatus;
};

export const mapAISummaryItemDtoToModel = (dto: AISummaryItemDto): AISummaryItemModel => ({
  paragraph: dto.paragraph,
  title: dto.title,
});

export const mapAISummariesDtoToModel = (dto: AISummariesDto): AISummariesModel => ({
  id: dto.id,
  sections: dto.sections.map(mapAISummaryItemDtoToModel),
  status: dto.status,
});
